<template>
  <div class="inline">
    <!-- <a @click="show()" style="margin: 5px;">查看作业</a> -->
    <a-button type="primary" htmlType="submit" icon="ordered-list" @click="show" style="margin: 5px;">查看作业</a-button>
    <a-modal :visible="homework_visible" @ok="homework_visible = false" :destroyOnClose="true" :footer="null"
      @cancel="homework_visible = false" width="1600px">
      <a-radio-group v-model="curr_mission_type" @change="changeMissionType">
        <a-radio-button v-for="(item) in mission_type_list" :key="item.id" :value="item.id">
          {{ item.name }}
        </a-radio-button>
      </a-radio-group>
      <a-table :dataSource="homeworkList" :rowKey="item => item.id" :pagination="false" :loading="loading"
        max-width="1000">
        <a-table-column style="max-width: 100px;" key="title" title="题目">
          <template slot-scope="item">
            <span v-html="item.title" />
          </template>
        </a-table-column>
        <a-table-column key="answer" title="系统答案" style="max-width: 100px;" data-index="answer" />
        <a-table-column key="user_answer" title="学生答案" :width="300">
          <template slot-scope="item">
            <img style="cursor: zoom-in" :preview="item.id"
              :large="item.user_answer + '?x-oss-process=image/resize,w_800/auto-orient,1'" :preview-text="'学生回答'"
              :src="item.user_answer + '?x-oss-process=image/resize,w_100,h_80/auto-orient,1'"
              v-if="item.typestr == 'ANSWER'" />
            <a-button type="primary" @click="video_path = item.user_answer; video_visible = true;"
              v-if="item.typestr == 'VIDEO'">播放</a-button>
            <a-button type="primary" @click="copysrc(item.user_answer)"
              v-if="item.user_answer.length > 0 && item.typestr == 'VIDEO'" style="margin-left: 5px;">复制</a-button>
            <!-- <a-button type="primary" @click="addLectureVideo(item)" :disabled="item.is_hot_video!=0" style="margin-left: 5px;" v-if="item.typestr=='VIDEO'" >{{item.is_hot_video==0?"推荐":"已推荐"}}</a-button> -->

            <template v-if="item.typestr == 'PREVIEW'">
              <span v-if="item.isright == 1 && item.correct == 1">{{ Math.floor(item.user_answer / 1000 / 60) }}分{{
                Math.floor((item.user_answer / 1000) % 60) }}秒</span>
              <span v-if="item.isright == 0 && item.correct == 0">未观看</span>
            </template>
            <span v-if="item.typestr == 'JUDGMENT' || item.typestr == 'COMPLETION' || item.typestr == 'SINGLE_CHOICE'">{{
              item.user_answer }}</span>
          </template>
        </a-table-column>
        <a-table-column key="correct" title="对错" :sorter="(item1, item2) => item1.isright - item2.isright" :width="60">
          <template slot-scope="item">
            <span v-if="item.correct == 0">未批改</span>
            <a-icon v-if="item.isright == 0 && item.correct == 1" type="close"
              :style="{ fontSize: '22px', color: 'red' }" />
            <a-icon v-if="item.isright == 1 && item.correct == 1" type="check"
              :style="{ fontSize: '22px', color: 'green' }" />
          </template>
        </a-table-column>
        <a-table-column key="comment" title="评语/语音" style="max-width: 200px;">
          <template slot-scope="item">
            <span v-if="item.correct == 0">未批改</span>
            <span v-if="item.correct == 1">{{ item.comment }}</span>
            <p>
              <audio style="max-width: 160px" :src="item.audio_path" v-if="item.correct == 1 && item.audio_path"
                controls />
            </p>
          </template>
        </a-table-column>

        <a-table-column key="jion_time" title="时间" :width="180">
          <template slot-scope="item">
            <span>{{ moment(item.tj_time * 1000).format('lll') }}</span>
          </template>
        </a-table-column>
      </a-table>
      <a-modal :visible="video_visible" title="视频播放" @ok="video_visible = false" :destroyOnClose="true" :footer="null"
        @cancel="video_visible = false">
        <video :src="video_path" style="max-width: 100%;max-height: 300px;" autoplay controls />
        <div style="text-align: right;margin-top: 1rem;">
          <a-button type="primary" @click="video_visible = false">关闭</a-button>
        </div>
      </a-modal>
    </a-modal>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    user_id: {
      type: String,
      require: true
    },
    squad_id: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      homework_visible: false,
      curr_mission_type: "jdcs",
      video_path: undefined,
      video_visible: false,
      loading: false,
      mission_type_list: [
        { id: "jdcs", name: "阶段测试" },
        { id: "mrcs", name: "每日测试" },
        { id: "mryl", name: "每日一练" },
        { id: "stcs", name: "随堂测试" },
        { id: "zwgg", name: "自我巩固" },
        { id: "zwjc", name: "自我检测" },
        { id: "zwsx", name: "自我实现" },
        { id: "zwyx", name: "自我预习" },
        { id: "zzlx", name: "自主练习" }],
      homeworkList: []
    };
  },
  mounted() {

  },

  show() {
    console.info("show");
  },
  methods: {
    handleCancel() {
      this.visible = false;
    },

    addLectureVideo(item) {
      this.loading = true;
      this.$axios
        .post("/api/StudentLecture/add_student_video", {
          data: {
            id: item.id
          }
        })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            item.is_hot_video = 1;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    copysrc(url) {

      var input = document.createElement("input"); // 创建input对象
      input.value = url; // 设置复制内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$message.success('成功复制')
      //this.$toast.success("成功复制订单号");



    },

    changeMissionType() {
      this.loading = true;
      this.$axios
        .post("/api/StudentHomeWork/get_student_homework", {
          data: {
            squad_id: this.squad_id,
            user_id: this.user_id,
            type_id: this.curr_mission_type
          }
        })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.homeworkList = res.data;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },


    async show() {
      this.loading = true;
      this.changeMissionType();
      this.homework_visible = true;
    },
    moment
  },
  watch: {},
  components: {},
};
</script>

<style lang="less" scoped>
.inline {
  display: inline;
  margin-right: 1rem;
}

.option {
  display: flex;

  .label {
    font-weight: bold;
  }

  .span {
    width: 0;
    flex: 1;
    margin-left: 0.5rem;
  }
}</style>